import { Next } from '@securitize/ui-components';

export const GET_AGREEMENT_NEXT = (opportunityId) => new Next(`/opportunities/${opportunityId}/agreement-document`,
  'GET_AGREEMENT_NEXT');
export const GET_AGREEMENT_BY_PULL_NEXT = (opportunityId) => new Next(`/opportunities/${opportunityId}/agreement-document`,
  'GET_AGREEMENT_BY_PULL_NEXT');
